import ScheduleItem from 'contentful/schedule_item';

const ScheduleGroup = ({ title, agenda }) => (
  <div className="event-schedule">
    {title && <h3 className="event-schedule__title">{title}</h3>}
    <div className="event-schedule__items">
      {agenda.map(({ sys: { id }, fields }) => (
        <ScheduleItem {...fields} key={id} />
      ))}
    </div>
  </div>
);

export default ScheduleGroup;
